<p class="c-pointer" [class]="class" [ngbTooltip]="tooltip" placement="bottom" container="body">
  {{ minutes | number: '2.0-0' }}:{{ seconds | number: '2.0-0' }}
</p>
